import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItemButton,
  ListItemText,
  Typography,
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { SINGLE_WAREHOUSE_ITEM_ID } from "../../../../../enums/UrlPaths";

export default function WarehouseCodeConflictsDialog({ conflicts, onClose }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Dialog
      open={Boolean(conflicts?.length)}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      data-testid="clinic.options.warehouse.conflicts-dialog"
    >
      <DialogTitle>{t("CodeConflictsFound")}</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {t("CodeConflictsDescription")}
        </Typography>
        <List disablePadding>
          {(conflicts ?? []).map((conflict) => (
            <ListItemButton
              key={conflict.itemId}
              onClick={() => navigate(SINGLE_WAREHOUSE_ITEM_ID.replace(":itemId", conflict.itemId))}
              data-testid={`clinic.options.warehouse.conflicts-dialog.item.${conflict.itemId}`}
            >
              <ListItemText primary={conflict.title} secondary={conflict.code} />
            </ListItemButton>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t("Close")}</Button>
      </DialogActions>
    </Dialog>
  );
}
